import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonTypeEnum } from '@panaya/ui/p-button';
import { PDialogFooterBtnActionType, DeactivateResult } from './p-dialog-footer-btn-config.interface';
@Component({
    selector: 'p-warning-with-action-dialog',
    template: `
        <p-dialog-container>
            <p-dialog-header title="{{ data.headerText }}"></p-dialog-header>
            <div class="p-dialog-content">
                {{ data.bodyText }}
            </div>
            <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
        </p-dialog-container>
    `
})
export class PWarningWithActionDialogComponent {
    @Output() okClick = new EventEmitter<boolean>();
    ButtonTypeEnum = ButtonTypeEnum;
    headerText?: string;
    bodyText?: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: { headerText: string; bodyText: string }, public dialogRef: MatDialogRef<boolean>) {}

    discard(): void {
        this.dialogRef.close(DeactivateResult.DISCARD);
    }

    save(): void {
        this.dialogRef.close(DeactivateResult.SAVE);
    }

    get footerConfig() {
        return [
            {
                click: () => this.discard(),
                text: 'Execution.dirtyEntity.discard'
            },
            {
                text: 'Execution.dirtyEntity.save',
                click: () => this.save()
            },
            {
                type: PDialogFooterBtnActionType.Close,
                text: 'Execution.dirtyEntity.stay_on_page'
            }
        ];
    }
}
